import CommonHeader from '@components/common/CommonHeader';
import NotificationManagementContainer from '@components/notification/NotificationManagementContainer';
import React from 'react';

function NotificationManagement() {
  return (
    <div id="notification_management">
      <CommonHeader>공지사항 관리</CommonHeader>
      <NotificationManagementContainer />
    </div>
  );
}

export default NotificationManagement;
